// src/components/AdminDashboard.js
import React from "react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-rose-50 flex flex-col">

      <main className="flex-1 max-w-6xl mx-auto px-4 py-8 md:py-10">

        {/* Title */}
        <div className="mb-6 md:mb-8 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
            Admin Dashboard
          </h1>
          <p className="mt-2 text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
            Manage rooms, tenants, and payments for{" "}
            <span className="font-semibold">Tender Castle Hostel</span>.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          
          {/* Rooms Management */}
          <Link
            to="/dashboard/rooms"
            className="bg-white/95 border border-amber-50 shadow-md rounded-2xl p-5 hover:shadow-xl transition-all flex flex-col items-center text-center"
          >
            <h2 className="text-lg font-semibold text-[#b4642d]">
              Rooms Management
            </h2>

            <p className="text-gray-500 mt-2 text-sm">
              View and manage available rooms, pricing, and status.
            </p>

            <span className="mt-4 inline-flex text-xs font-semibold text-[#b4642d] bg-orange-50 px-4 py-1.5 rounded-full">
              Go to Rooms
            </span>
          </Link>

          {/* Tenants */}
          <Link
            to="/dashboard/tenants"
            className="bg-white/95 border border-amber-50 shadow-md rounded-2xl p-5 hover:shadow-xl transition-all flex flex-col items-center text-center"
          >
            <h2 className="text-lg font-semibold text-[#b4642d]">
              Tenants
            </h2>

            <p className="text-gray-500 mt-2 text-sm">
              Manage tenant profiles, status, and room assignments.
            </p>

            <span className="mt-4 inline-flex text-xs font-semibold text-[#b4642d] bg-orange-50 px-4 py-1.5 rounded-full">
              Go to Tenants
            </span>
          </Link>

          {/* Payments */}
          <Link
            to="/dashboard/payments"
            className="bg-white/95 border border-amber-50 shadow-md rounded-2xl p-5 hover:shadow-xl transition-all flex flex-col items-center text-center"
          >
            <h2 className="text-lg font-semibold text-[#b4642d]">
              Payments
            </h2>

            <p className="text-gray-500 mt-2 text-sm">
              Track and review payment records.
            </p>

            <span className="mt-4 inline-flex text-xs font-semibold text-[#b4642d] bg-orange-50 px-4 py-1.5 rounded-full">
              Go to Payments
            </span>
          </Link>

        </div>
      </main>
    </div>
  );
}
